/*@flow*/
import type { Node } from "react";
import React from "react";
import { mkComponent, type PickerProps } from "./Resources";

export function AssociatedRecord(props: PickerProps): Node {
  return React.createElement(
    mkComponent({
      placeholder: "Select a contact",
      targetRelation: "contacts",
      isMulti: true,
    }),
    props
  );
}
